import { APP_BRAND } from '@/config/brand';
import { getBrandConfig } from '@/config/brandConfig';
import { useId } from 'react';
import { AssetIcon } from './AssetIcon';
import { cn } from '@/utils/helpers';

export type BulkUploadFileIconProps = {
  className?: string;
};

/** CSV import document icon for bulk-import empty upload drop zone. */
export function BulkUploadFileIcon({ className }: BulkUploadFileIconProps) {
  const brandConfig = getBrandConfig();
  const clipId = useId();

  if (APP_BRAND === 'hid' && brandConfig.hidFileUploadIcon) {
    return (
      <AssetIcon
        src={brandConfig.hidFileUploadIcon}
        width={75}
        height={87}
        className={cn('bulk-upload-file-icon', className)}
        alt=""
        aria-hidden
      />
    );
  }

  return (
    <svg
      width="75"
      height="87"
      viewBox="0 0 75 87"
      fill="none"
      className={cn('bulk-upload-file-icon', className)}
      aria-hidden
    >
      <circle cx="37.2947" cy="49.5311" r="37.2947" className="bulk-upload-file-icon__halo" />
      <g clipPath={`url(#${clipId})`}>
        <rect x="6.11133" width="62.675" height="81.9519" fill="white" />
        <rect x="5.75635" width="63.03" height="19.2812" className="bulk-upload-file-icon__header" />
        <rect x="9.72852" y="3.93555" width="25.6024" height="3.08989" rx="1.54494" fill="white" />
        <rect
          x="9.72852"
          y="23.0332"
          width="25.6024"
          height="3.08989"
          rx="1.54494"
          className="bulk-upload-file-icon__line-accent"
        />
        <rect
          x="9.72852"
          y="36.7168"
          width="23.665"
          height="3.08989"
          rx="1.54494"
          className="bulk-upload-file-icon__line-accent"
        />
        <rect
          x="9.72852"
          y="53.0586"
          width="29.457"
          height="3.08989"
          rx="1.54494"
          className="bulk-upload-file-icon__line-accent"
        />
        <rect x="9.72852" y="10.7773" width="39.2546" height="3.08989" rx="1.54494" fill="white" />
        <rect
          x="9.72852"
          y="29.875"
          width="44.5575"
          height="3.08989"
          rx="1.54494"
          className="bulk-upload-file-icon__line-muted"
        />
        <rect
          x="9.72852"
          y="43.5605"
          width="44.5575"
          height="3.08989"
          rx="1.54494"
          className="bulk-upload-file-icon__line-muted"
        />
        <rect
          x="9.72852"
          y="59.9023"
          width="48.281"
          height="3.08989"
          rx="1.54494"
          className="bulk-upload-file-icon__line-muted"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect x="6.11133" width="62.675" height="86.8257" rx="3.53327" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
